import React, { useEffect, useState } from "react";
import { AiOutlineLoading3Quarters } from "react-icons/ai";
import { IoWarning } from "react-icons/io5";
import { useParams } from "react-router-dom";
import { serverInstance } from "../../service/axios";
import AnnualMeeting from "./AnnualMeeting";
import "./pastMeeting.scss";

const PastMeeting = ({ data, language }) => {
  const params = useParams();
  const [event, setEvent] = useState(null);
  const [errorMsg, setErrorMsg] = useState("");
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (!params.id) {
      setLoading(false);
      return;
    }

    let isMounted = true;
    setLoading(true);

    serverInstance.post("/app/item", { class: "meeting", id: params.id }, {
      headers: {
        "Content-Type": "application/json",
      }
    })
      .then(res => {
        if (!isMounted) return;

        const item = res.data?.item;
        setEvent(item ? {
          ...item,
          speakers: res.data?.speakers || [],
          sponsors: res.data?.sponsors || [],
          rows: res.data?.rows || [],
        } : null);
        setLoading(false);
        setErrorMsg("");
      })
      .catch((err) => {
        if (!isMounted) return;

        setLoading(false);
        setErrorMsg(err?.message || String(err));
      });

    return () => {
      isMounted = false;
    };
  }, [params.id]);

  return (
    <div className="event meeting-container items-container d-flex flex-column align-items-center">
      {loading ? (
        <AiOutlineLoading3Quarters size={25} className="loading-spinner" />
      ) : null}

      {errorMsg ? (
        <div className="error-msg">
          <IoWarning />
          &nbsp;
          {errorMsg}
        </div>
      ) : null}

      {!loading && !errorMsg ? (
        <section className="meeting-main">
          <div className="meeting-content">
            <AnnualMeeting
              data={data}
              item={event}
              language={language}
              showRegistration={false}
            />
          </div>
        </section>
      ) : null}
    </div>
  );
}

export default PastMeeting;
